/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

import { Container, Section } from '../../styled/containers';
import { GlobalStyle } from '../../theme/global';

import { ErrorContainer } from './styles.js';
import { usePageMeta } from '../../page';
import contentfulLink from '../../../utils/contentful-link';

const TemplateHandler = ({ error, name }) => {
  if (process.env.NODE_ENV === 'production' && !process.env.PREVIEW) {
    throw error;
  }

  const { contentfulId } = usePageMeta();

  const onViewStackTrace = (event) => {
    event.stopPropagation();
    console.error(error);
  };

  return (
    <>
      <GlobalStyle />
      <Container>
        <Section>
          <ErrorContainer>
            <p>
              An error occurred in the following page template:{' '}
              <strong>{name}</strong>.
            </p>
            <p>
              You are seeing this warning because you are previewing this page.
              This page should not be published. If this page is already
              published, please contact a developer immediately.
            </p>
            <p>To troubleshoot this issue:</p>
            <ul>
              <li>
                Make sure the page is configured correctly{' '}
                <a href={contentfulLink(contentfulId)}>in contentful</a>
              </li>
              <li>
                Contact a developer. Provide them with as much information as
                possible
              </li>
            </ul>
            <p>
              <a href="#" onClick={onViewStackTrace}>
                stacktrace
              </a>
            </p>
          </ErrorContainer>
        </Section>
      </Container>
    </>
  );
};

TemplateHandler.propTypes = {
  error: PropTypes.object.isRequired,
  name: PropTypes.string,
};

export default TemplateHandler;
